module.exports = __webpack_public_path__ + "img/master card.b04d9348.png";